<div class="flex layout-column layout-align-center-center" (click)="clickEvent.emit()">
  <span class="value"
        [style.font-size.rem]="size"
        [style.color]="color">{{ isNumeric(value) ? (value | number) : value }}</span>
</div>
